// Storefront theme registry — layout templates, separate from colour/branding.
export const THEMES = [
  { id: "classic", label: "Classic", tagline: "Balanced grid storefront for any store", desc: "A clean, familiar grid with hero banner, category pills and product cards." },
  { id: "visual-grid", label: "Visual Grid", tagline: "Fashion & Apparel", desc: "Lookbook hero, image-led cards and prominent size/variant swatches." },
  { id: "market-dense", label: "Market Dense", tagline: "Grocery & FMCG", desc: "Compact grid, quantity steppers up front, category shortcuts for quick reorder." },
  { id: "tech-spec", label: "Tech Spec", tagline: "Electronics", desc: "Spec badges, EMI/warranty chips and a tabbed specs product page." },
  { id: "artisan-story", label: "Artisan Story", tagline: "Handicrafts & Artisan", desc: "Storytelling hero with a maker-story section, large imagery, minimal clutter." },
];

export const BUSINESS_CATEGORIES = [
  { id: "fashion-apparel", label: "Fashion & Apparel", theme: "visual-grid" },
  { id: "grocery-fmcg", label: "Grocery & FMCG", theme: "market-dense" },
  { id: "electronics", label: "Electronics", theme: "tech-spec" },
  { id: "handicrafts-artisan", label: "Handicrafts & Artisan", theme: "artisan-story" },
  { id: "food-beverage", label: "Food & Beverage", theme: "market-dense" },
  { id: "home-living", label: "Home & Living", theme: "classic" },
  { id: "health-beauty", label: "Health & Beauty", theme: "classic" },
  { id: "other", label: "Other", theme: "classic" },
];

export const themeOf = (id) => THEMES.find((t) => t.id === id) || THEMES[0];
export const themeForCategory = (cid) => (BUSINESS_CATEGORIES.find((c) => c.id === cid) || {}).theme || "classic";
